import { IconType } from 'react-icons'
import { cn } from '../../utils/cn'

interface Props {
  icon: IconType
  onClick: () => void
  /** Describes the action; also the tooltip while the action is available. */
  label: string
  disabled?: boolean
  /** Shown instead of `label` while disabled, to explain why. */
  disabledTitle?: string
  className?: string
}

/**
 * A row action such as edit or delete. These used to be bare icons carrying an
 * `onClick`, which no keyboard could reach and nothing could disable; wrapping
 * them in a real button fixes both and gives read-only mode one place to turn
 * them off.
 */
const IconAction = ({
  icon: Icon,
  onClick,
  label,
  disabled = false,
  disabledTitle,
  className,
}: Props) => (
  <button
    type='button'
    aria-label={label}
    title={disabled ? disabledTitle : label}
    disabled={disabled}
    onClick={onClick}
    className={cn(
      'text-lg transition-opacity',
      disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:opacity-80',
      className,
    )}
  >
    <Icon />
  </button>
)

export default IconAction
